import { Skeleton } from './Skeleton';

export function SkeletonProjectCard() {
  return (
    <div className="showcase-card skeleton-card" style={{ marginBottom: 12 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          marginBottom: 12,
        }}
      >
        <Skeleton width={44} height={44} borderRadius={13} />
        <div style={{ flex: 1 }}>
          <Skeleton
            width="55%"
            height={14}
            style={{ marginBottom: 6 }}
          />
          <Skeleton width="35%" height={10} />
        </div>
      </div>
      <Skeleton width="90%" height={10} style={{ marginBottom: 6 }} />
      <Skeleton width="70%" height={10} style={{ marginBottom: 12 }} />
      <div style={{ display: 'flex', gap: 6 }}>
        <Skeleton width={60} height={22} borderRadius={7} />
        <Skeleton width={50} height={22} borderRadius={7} />
        <Skeleton width={65} height={22} borderRadius={7} />
      </div>
    </div>
  );
}
